import type { ObjectId } from "@bbj-types/utils";
import { Checkbox, Divider, Stack, Typography } from "@mui/material";
import { useAuthorizer } from "@styleguide";
import clsx from "clsx";
import type { Dispatch, SetStateAction } from "react";
import { RefusedCandidatesTableRow, classes } from "./styles";

export const RefusedCandidatesHeader = ({
  allSocialApply,
  socialApplySelected,
  setSocialApplySelected,
}: {
  allSocialApply: ObjectId[];
  socialApplySelected: ObjectId[];
  setSocialApplySelected: Dispatch<SetStateAction<ObjectId[]>>;
}) => {
  const isAuthorizedArchive = useAuthorizer(["offers.social.archive"]);
  return (
    <RefusedCandidatesTableRow
      sx={{ flex: "auto", scrollbarGutter: "stable" }}
      isAuthorizedArchive={isAuthorizedArchive}
    >
      <Stack className={clsx(classes.root, classes.header)}>
        {isAuthorizedArchive && (
          <Checkbox
            size="small"
            color="primary"
            indeterminate={socialApplySelected.length > 0 && allSocialApply.length !== socialApplySelected.length}
            checked={socialApplySelected.length > 0}
            onClick={() => {
              if (socialApplySelected.length > 0) {
                setSocialApplySelected([]);
              } else {
                setSocialApplySelected(allSocialApply);
              }
            }}
          />
        )}
        <Typography className={`${classes.cell} ${classes.candidate}`} variant="subtitle2SemiBold" color="primary">
          Candidat
        </Typography>
        <Typography className={`${classes.cell} ${classes.prescription}`} variant="subtitle2SemiBold" color="primary">
          Prescription
        </Typography>
        <Typography className={`${classes.cell} ${classes.date}`} variant="subtitle2SemiBold" color="primary">
          Date de réponse
        </Typography>
        <Typography className={`${classes.cell} ${classes.cause}`} variant="subtitle2SemiBold" color="primary">
          Motif
        </Typography>
        <Typography className={`${classes.cell} ${classes.author}`} variant="subtitle2SemiBold" color="primary">
          Auteur
        </Typography>
      </Stack>
      <Divider />
    </RefusedCandidatesTableRow>
  );
};
